// extracted by mini-css-extract-plugin
module.exports = {"login":"styles_login__30PAe","register":"styles_register__79Ai-","forgot":"styles_forgot__9nfKi","dontHaveAccount":"styles_dontHaveAccount__3Kajn","signUp":"styles_signUp__2erKf"};